import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as toastr from 'toastr';
import { VideozapisiService } from '../videozapisi/videozapisi.service';
import { PravaPristupa } from './prava-pristupa';
import { Subject } from 'rxjs';
import * as moment from 'moment';
import { ScriptLoaderService } from '../../../_services/script-loader.service';
import { PravaPristupaService } from './prava-pristupa.service';

@Component({
  selector: 'app-prava-pristupa',
  templateUrl: './prava-pristupa.component.html',
  styleUrls: ['./prava-pristupa.component.css'],
  providers: [PravaPristupaService, VideozapisiService]
})
export class PravaPristupaComponent implements OnInit {

  myDatePickerOptions = {
		todayBtnTxt: 'Danas',
		dateFormat: 'dd.mm.yyyy',
		firstDayOfWeek: 'mo',
		sunHighlight: true,
		height: '34px',
		width: '100%',
		inline: false,
		selectionTxtFontSize: '16px',
		dayLabels: {su: 'Ned', mo: 'Pon', tu: 'Uto', we: 'Sri', th: 'Čet', fr: 'Pet', sa: 'Sub'},
		monthLabels: { 1: 'Sij', 2: 'Velj', 3: 'Ožu', 4: 'Tra', 5: 'Svi', 6: 'Lip', 7: 'Srp', 8: 'Kol', 9: 'Ruj', 10: 'Lis', 11: 'Stu', 12: 'Pro' }
	};

  dodaniVideozapisi: PravaPristupa[] = [];
  neDodaniVideozapisi: PravaPristupa[] = [];

  video1Options: DataTables.Settings = {};
  video1Trigger: Subject<PravaPristupa> = new Subject();

  video2Options: DataTables.Settings = {};
  video2Trigger: Subject<PravaPristupa> = new Subject();

  idKorisnik: string;
  imeKorisnik: string;

  dostupanOd: any;
  dostupanOdSlanje: any;
  dostupanDo: any;
  dostupanDoSlanje: any;

  naziv: string;
  videoId: string;
  trenutnoGledanja: number;
  maksimalnoGledanja: number;
  kljuc: string;
  id: string;

  statistikaPregledaVidea: any;

  idVideo: string;

  constructor(
    public _pravaPristupa: PravaPristupaService,
    private _route: ActivatedRoute,
    private _script: ScriptLoaderService
    ) { 
    
    this.idKorisnik = this._route.snapshot.params.idKorisnik; 
    this.imeKorisnik = this._route.snapshot.params.ime; 
    // console.log(this.idKorisnik);
  
    let myDate = new Date();
    myDate.setDate(myDate.getDate() + 1);
    let danasnjiDatum = new Date().toISOString();
    this.dostupanOd = moment(danasnjiDatum).format('DD.MM.YYYY.');
    this.dostupanOdSlanje = moment(danasnjiDatum).format('YYYY-MM-DD');
    let sutrasnjiDatum = myDate.toISOString();
    this.dostupanDo = moment(sutrasnjiDatum).format('DD.MM.YYYY.');
    this.dostupanDoSlanje = moment(sutrasnjiDatum).format('YYYY-MM-DD');
  }

  ngOnInit() {
    this.dohvati();
  }

  reInit() {
    $('#videozapisiTablica1').DataTable().destroy()
    $('#videozapisiTablica2').DataTable().destroy()
    this.dohvati();
  }
 
  provjeraDatumaOd(event:any) {
    // console.log(event);
    this.dostupanOdSlanje = event.date.year + '-' + event.date.month + '-' + event.date.day;
    // console.log(this.dostupanOdSlanje);
}

provjeraDatumaDo(event:any) {
    // console.log(event);
    this.dostupanDoSlanje = event.date.year + '-' + event.date.month + '-' + event.date.day;
}


  dohvati(){
    this.neDodaniVideozapisi = [];
    this.dodaniVideozapisi = [];
    this._pravaPristupa.dohvati({'idKorisnika': this.idKorisnik, 'access_token': localStorage.getItem('token')}).subscribe(res => {
        // console.log(res);
        if(res['nedodaniVidei']){
          for(let i = 0; i < res['nedodaniVidei'].length; i++){
              if(res['nedodaniVidei'][i]['id'] && res['nedodaniVidei'][i]['naziv']){
                this.neDodaniVideozapisi.push({
                  'id': res['nedodaniVidei'][i]['id'],
                  'idVideo': res['nedodaniVidei'][i]['id'],
                  'naziv': res['nedodaniVidei'][i]['naziv'],
                  'dostupanOd': '',
                  'dostupanDo': '',
                  'maksimalnoGledanja': 0,
                  'trenutnoGledanja': 0,
                  'kljuc': '',
                  'gledano': ''
                });
              }
          }
          this.video1Trigger.next();
        }
        if(res['dodaniVidei']){
          for(let i = 0; i < res['dodaniVidei'].length; i++){
            if(res['dodaniVidei'][i]['id'] && res['dodaniVidei'][i]['video']){
              this.dodaniVideozapisi.push({
                'id': res['dodaniVidei'][i]['id'],
                'idVideo': res['dodaniVidei'][i]['idVideo'],
                'naziv': res['dodaniVidei'][i]['video'],
                'dostupanOd': moment(res['dodaniVidei'][i]['odDatum']).format('DD.MM.YYYY.'),
                'dostupanDo': moment(res['dodaniVidei'][i]['doDatum']).format('DD.MM.YYYY.'),
                'maksimalnoGledanja': res['dodaniVidei'][i]['dozvoljenBroj'],
                'trenutnoGledanja': res['dodaniVidei'][i]['gledanjaBroj'],
                'kljuc': res['dodaniVidei'][i]['password'],
                'gledano': res['dodaniVidei'][i]['gledano']
              });
            }
         }
         this.video2Trigger.next();
        }
        // console.log(this.neDodaniVideozapisi);
        // console.log(this.dodaniVideozapisi);
    });

  }

  pripremi(a){
    //  console.log(a);
    this.naziv = a.naziv;
    this.id = a.id;
    this.idVideo = a.idVideo;
    this.trenutnoGledanja = a.trenutnoGledanja;
    //Kreiranje kljuca
    const znakovi = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    const kljucPrivremeno = Array.from({length:5}, _ => znakovi[Math.floor(Math.random()*znakovi.length)]).join('')
    this.kljuc = kljucPrivremeno;
  }

  dodaj(naziv, maksimalnoGledanja, kljuc){
    // console.log(naziv);
    // console.log(maksimalnoGledanja);
    // console.log(kljuc);
    if(!maksimalnoGledanja){
      toastr.error("Nisu unesevni svi podaci!");
    } else if (maksimalnoGledanja == 0) {
      toastr.error("Maksimalan broj pregleda ne može biti nula!");
    } else {
      let podaciZaSlanje = {
        'id': this.id,
        'video': naziv,
        'idVideo': this.idVideo,
        'odDatum': this.dostupanOdSlanje,
        'doDatum': this.dostupanDoSlanje,
        'dozvoljenBroj': maksimalnoGledanja,
        'gledanjaBroj': this.trenutnoGledanja,
        'password': kljuc,
        'user': this.idKorisnik 
    };
      // console.log(podaciZaSlanje);
    this._pravaPristupa.dodajPrava(podaciZaSlanje).subscribe(res => {
      // console.log(res);
       if(res['createdAt']){
         this.reInit();
       }
    });
    }
  }

  pripremi2(a){
    // console.log(a);
    this.id = a.id;
    this.naziv = a.naziv;
    this.videoId = a.idVideo;
    this.trenutnoGledanja = a.trenutnoGledanja;
    this.dostupanOd = a.dostupanOd;
    this.dostupanDo = a.dostupanDo;
    this.maksimalnoGledanja = a.maksimalnoGledanja;
    this.kljuc = a.kljuc;
  }

  uredi2(naziv, maksimalnoGledanja, kljuc){
    // console.log(naziv);
    // console.log(maksimalnoGledanja);
    // console.log(kljuc);
    if(!maksimalnoGledanja){
      toastr.error("Nisu unesevni svi podaci!");
    } else if (maksimalnoGledanja == 0) {
      toastr.error("Maksimalan broj pregleda ne može biti nula!");
    } else {
      let podaciZaSlanje = {
        'idVideo': this.videoId,
        'id': this.id,
        'video': naziv,
        'odDatum': this.dostupanOdSlanje,
        'doDatum': this.dostupanDoSlanje,
        'dozvoljenBroj': maksimalnoGledanja,
        'gledanjaBroj': this.trenutnoGledanja,
        'password': kljuc,
        'user': this.idKorisnik,
        'access_token': localStorage.getItem('tokenMongo')
    };
      // console.log(podaciZaSlanje);
    this._pravaPristupa.urediPrava(this.id, podaciZaSlanje).subscribe(res => {
      //  console.log(res);
      this.reInit();
    });
    }
  }

  statistikaPregleda(pr){
    this.statistikaPregledaVidea = [];
    for(let i = 0; i < pr.gledano.length; i++){
       this.statistikaPregledaVidea.push(
         {'s': moment(pr.gledano[i]).format('DD.MM.YYYY. - HH:mm:ss') + 'h'}
       );
    }
  }

  ngAfterViewInit() {
    this._script.load('./assets/js/scripts/form-plugins.js');
  }

}


// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/pages/vimeo/prava-pristupa/prava-pristupa.component.ts